/**
 * DRM Account entity class
 */

/**
 * DRMAccountFactory
 * returns DRM Account entity class
 *
 * @class DRMAccountFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DRMAccount} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DRMAccountFactory
 */
/* @ngInject */
export default function DRMAccountFactory ($http, Entity, Type, DRMProfile, m2mMixin, onOffMixin, alertLiteSvc) {
  /* === DRMAccount class === */

  /**
   * DRMAccount model
   *
   * @class DRMAccount
   * @classdesc DRMAccount model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing DRMAccount entity fields
   * @return {models.DRMAccount} DRMAccount entity
   */
  function DRMAccount () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DRMAccount.prototype = Object.create(Entity.prototype)
  DRMAccount.prototype.constructor = DRMAccount

  /* === DRMAccount instance methods & fields === */

  Object.assign(DRMAccount.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DRMAccount#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      $profiles: [],
      accessKey: String,
      accountId: String,
      apiKey: String,
      clientId: String,
      clientSecret: String,
      drmProfilesCount: Number,
      enabled: true,
      icHost: String,
      pxValue: String,
      siteId: String,
      siteKey: String,
      type: String,
      userBasedBilling: Boolean
    },

    /**
     * url template
     *
     * @memberof models.DRMAccount#
     * @type {String}
     */
    _urlTemplate: 'api/drm/accounts/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.DRMAccount#
     * @type {String}
     */
    _publicUrlTemplate: 'drmaccounts/{{::id}}'

  }, onOffMixin)

  /* === DRM Account static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DRMAccount, Entity)
  DRMAccount._name = 'DRMAccount'
  DRMAccount.init()

  // permissions
  DRMAccount.access = {
    view: 'viewDRMAccount',
    create: 'createDRMAccount',
    edit: 'editDRMAccount',
    delete: 'deleteDRMAccount'
  }

  return DRMAccount
}
